module.exports = __webpack_public_path__ + "img/M1_BK_15.cc0f15b6.png";